import produce from 'immer';
import React from 'react';
import { constants } from '../actions/constants/pacientes.constants';
import Encargo from '../../modules/pacientes/components/activity/encargo';
import Optometria from '../../modules/pacientes/components/activity/optometria';
import Contactologia from '../../modules/pacientes/components/activity/contactologia';
import moment from 'moment';

const initialState = {
  loadingPacientes: false,
  loadingPhotos: false,
  loadingFields: false,
  pacienteDuplicado: false,
  pacienteEsperandoGuardado: false,
  pacientes: [],
  totalPacientes: 0,
  pacienteSelected: null,
  grupos_cliente: [],
  profesiones: [],
  tiendas: [],
  fieldsToValidate: [],
  grpd: '',
  rawNote: '',
  notas: '',
  insurances: {},
  error: null,
  paises: [],
  provincias: [],
  mutuas: [],
  identificadores: [],
  camposPersonalizados: [],
  camposDinamicos: [],
  encargos: [],
  activity: [],
  keyword: '',
  page: 1,
  sorter: null,
  tiendaId: -1,
  imagen: null,
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case constants.PACIENTES_INIT_WORKSPACE_SUCCESS: {
      return {
        ...draft,
        ...initialState,
      };
    }

    case constants.PACIENTES_SET_WORKSPACE: {
      return {
        ...draft,
      };
    }
    case constants.PACIENTES_SET_KEYWORD_STATE: {
      return {
        ...draft,
        keyword: payload,
        page: 1
      };
    }
    case constants.PACIENTES_SET_FILTER_TIENDA_STATE: {
      return {
        ...draft,
        page: 1,
        tiendaId: payload
      };
    }
    case constants.PACIENTES_GET_PACIENTES_REQUEST: {
      const { page, sorter } = payload;
      return {
        ...draft,
        loadingPacientes: true,
        page: page ? page : draft.page,
        sorter: sorter ? sorter : draft.sorter,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_REQUEST_SUCCESS: {
      const { pacientes, totalPacientes } = payload;
      return {
        ...draft,
        loadingPacientes: false,
        pacientes,
        totalPacientes,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_REQUEST_NOT_UPDATE: {
      return {
        ...draft,
        loadingPacientes: false,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_REQUEST_FAILURE: {
      return {
        ...draft,
        loadingPacientes: false,
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_GET_PACIENTE_REQUEST: {
      return {
        ...draft,
        loadingPacientes: false,
        pacienteSelected: null,
      };
    }
    case constants.PACIENTES_GET_PACIENTE_REQUEST_SUCCESS: {
      return {
        ...draft,
        loadingPacientes: false,
        pacienteSelected: payload,
        camposDinamicos: payload?.campos_dinamicos || [],
      };
    }
    case constants.PACIENTES_GET_PACIENTE_REQUEST_FAILURE: {
      return {
        ...draft,
        loadingPacientes: false,
        pacienteSelected: null,
        camposDinamicos: [],
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_GET_IDENTIFICADORES_SUCCESS: {
      return {
        ...draft,
        identificadores: payload,
      };
    }
    case constants.PACIENTES_GET_IDENTIFICADORES_FAILURE: {
      return {
        ...draft,
        identificadores: [],
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_GET_PACIENTES_PROFESIONES_SUCCESS: {
      return {
        ...draft,
        profesiones: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_PROFESIONES_FAILURE: {
      return {
        ...draft,
        profesiones: [],
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_GET_PACIENTES_TIENDAS: {
      return {
        ...draft,
        loadingTiendas: true,
        tiendas: [],
      };
    }
    case constants.PACIENTES_GET_PACIENTES_TIENDAS_SUCCESS: {
      return {
        ...draft,
        loadingTiendas: false,
        tiendas: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_TIENDAS_FAILURE: {
      return {
        ...draft,
        loadingTiendas: false,
        tiendas: [],
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_GET_PACIENTES_GROUPS_SUCCESS: {
      return {
        ...draft,
        grupos_cliente: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_GROUPS_FAILURE: {
      return {
        ...draft,
        grupos_cliente: [],
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_GET_PACIENTE_RGPD_SUCCESS: {
      return {
        ...draft,
        grpd: payload.rgpd,
      };
    }

    case constants.PACIENTES_GET_PACIENTE_RGPD_FAILURE: {
      return {
        ...draft,
        grpd: '',
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_SAVE_PACIENTE_RGPD_SUCCESS: {
      return {
        ...draft,
        pacienteSelected: {
          ...draft.pacienteSelected,
          rgpd_com_comerciales: true
        }
      };
    }


    case constants.PACIENTES_SAVE_PACIENTE_RGPD_FAILURE: {
      return {
        ...draft,
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_SET_PACIENTE_RGPD_CONDITIONS: {
      return {
        ...draft,
        grpd: payload,
      };
    }


    case constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST_SUCCESS: {
      return {
        ...draft,
        notas: payload,
      };
    }

    case constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST_FAILURE: {
      return {
        ...draft,
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST_SUCCESS: {
      return {
        ...draft,
        notas: payload,
      };
    }

    case constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST_FAILURE: {
      return {
        ...draft,
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_SUCCESS: {
      return {
        ...draft,
        insurances: payload,
      };
    }

    case constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_FAILURE: {
      return {
        ...draft,
        insurances: {},
        error: payload.toString(),
      };
    }


    case constants.PACIENTES_GET_PACIENTES_PAISES: {
      return {
        ...draft,
        paises: [],
      };
    }
    case constants.PACIENTES_GET_PACIENTES_PAISES_SUCCESS: {
      return {
        ...draft,
        paises: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_PAISES_FAILURE: {
      return {
        ...draft,
        paises: [],
        error: payload.toString(),
      };
    }


    case constants.PACIENTES_GET_PACIENTES_PROVINCIAS: {
      return {
        ...draft,
        provincias: [],
      };
    }
    case constants.PACIENTES_GET_PACIENTES_PROVINCIAS_SUCCESS: {
      return {
        ...draft,
        provincias: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_PROVINCIAS_FAILURE: {
      return {
        ...draft,
        provincias: [],
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_GET_PACIENTES_MUTUAS: {
      return {
        ...draft,
        mutuas: [],
      };
    }
    case constants.PACIENTES_GET_PACIENTES_MUTUAS_SUCCESS: {
      return {
        ...draft,
        mutuas: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTES_MUTUAS_FAILURE: {
      return {
        ...draft,
        mutuas: [],
        error: payload.toString(),
      };
    }

    case constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS: {
      return {
        ...draft,
        camposPersonalizados: [],
        loadingFields: true,
      };
    }
    case constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_SUCCESS: {
      return {
        ...draft,
        camposPersonalizados: payload,
        loadingFields: false,
      };
    }
    case constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_FAILURE: {
      return {
        ...draft,
        camposPersonalizados: [],
        error: payload.toString(),
        loadingFields: false,
      };
    }

    case constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS: {
      return {
        ...draft,
        camposDinamicos: [],
      };
    }
    case constants.PACIENTES_GET_PACIENTE_ENCARGO_SUCCESS: {
      return {
        ...draft,
        encargos: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_SUCCESS: {
      return {
        ...draft,
        camposDinamicos: payload,
      };
    }
    case constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_FAILURE: {
      return {
        ...draft,
        camposDinamicos: [],
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_CREATE_PACIENTE_REQUEST_FAILURE: {
      return {
        ...draft,
        error: payload.toString(),
      };
    }
    case constants.PACIENTES_CREATE_PACIENTE_REQUEST_SUCCESS: {
      return {
        ...draft,
        pacienteDuplicado: false,
        pacienteEsperandoGuardado: false,
      };
    }
    case constants.GET_ACTIVITY_DATA_SUCCESS: {
      const { encargos, optometrias, contactologias } = payload;
      const encargosM = encargos.map((e:any) => ({ ...e, fecha: e.fecha_emision, tipoElemento: 'encargo' }));
      const optometriasM = optometrias.map((e:any) => ({ ...e, tipoElemento: 'optometria' }));
      const contactologiasM = contactologias.map((e:any) => ({ ...e, tipoElemento: 'contactologia' }));
      const activity = [...encargosM, ...optometriasM, ...contactologiasM].sort((a, b) => moment(b.fecha, 'DD/MM/YYYY HH:mm:ss')?.diff(moment(a.fecha, 'DD/MM/YYYY HH:mm:ss')));
      return { ...draft, activity };
    }

    case constants.COMPROBAR_PACIENTE_DUPLICADO_SUCCESS: {
      return {
        ...draft,
        pacienteDuplicado: payload,
        pacienteEsperandoGuardado: true,
      };
    }
    case constants.PACIENTES_UNSET_PACIENTE_DUPLICADO: {
      return {
        ...draft,
        pacienteDuplicado: false,
        pacienteEsperandoGuardado: true,
      };
    }
    case constants.GET_PHOTO_PACIENTE_REQUEST: {
      return {
        ...draft,
        loadingPhotos: true
      };
    }

    case constants.GET_PHOTO_PACIENTE_REQUEST_SUCCESS: {
      return {
        ...draft,
        imagen: payload,
        loadingPhotos: false
      };
    }

    case constants.GET_PHOTO_PACIENTE_REQUEST_FAILURE:{
      return {
        ...draft,
        error: payload.toString(),
        loadingPhotos: false
      }
    }

    default:
      return draft;
  }
});
